module.exports = require('./helpers/bundle-url').getBundleURL('jWbtw') + "Solana.f2db1e5a.png";